export default {
  "video_player": "fWXho",
  "videoOverlay": "wMOWG",
  "video_container": "ycXdz"
};